import clsx from "clsx"
import { X } from "lucide-react"
import type { HTMLProps, ReactNode } from "react"
import type { Severity } from "@/shared/types/index.ts"
import { getIconColor } from "../provider/utils/utils.ts"

interface ToastProps {
  type: Severity
  message: string
  title?: string
  icon?: ReactNode
  onClose?: () => void
}

export function ToastContent({ message, icon, type, title, onClose, ...props }: ToastProps & HTMLProps<HTMLDivElement>) {
  const animationClass = props.className?.includes("animate-toastLeave") ? "animate-toastLeave" : "animate-toastEnter"

  return (
    <div
      {...props}
      className={clsx(
        "relative flex w-[500px] items-center gap-3 rounded-xl border-[3px] border-white px-4 py-5 shadow-[0_8px_24px_rgba(0,0,0,0.12)] transition-all",
        animationClass,
        props.className
      )}
    >
      <div className={clsx("flex size-6 items-center justify-center rounded-full border-2 border-white shadow", getIconColor(type))}>{icon}</div>

      <div className="text-zinc-900">
        {title && <h3 className="font-semibold">{title}</h3>}
        <p className="text-sm leading-tight">{message}</p>
      </div>

      <button
        onClick={onClose}
        aria-label="Close"
        className="absolute top-2 right-2 rounded-md p-1 text-slate-500 hover:bg-slate-100 hover:text-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-400 active:bg-slate-200"
      >
        <X className="size-[18px]" />
      </button>
    </div>
  )
}
